import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ContentProvider } from "@/content/ContentContext";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import NarrativeManifesto from "@/components/NarrativeManifesto";
import FourPillars from "@/components/FourPillars";
import EcentraLegacySection from "@/components/EcentraLegacySection";
import TwinImpactSections from "@/components/TwinImpactSections";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import AdminPage from "@/pages/AdminPage";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ContentProvider>
      <div className="bg-obsidian text-foreground min-h-screen" data-testid="app-root">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <HeroSection />
          <EditorialMarquee />
          <NarrativeManifesto />
          <EcentraLegacySection />
          <FourPillars />
          <TwinImpactSections />
          <ContactSection />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </ContentProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
